import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import ArticleLibraryRoute from "./routes";
import { MODEL_AUTH } from "./constants/model_auth";

import "./rails";
import "./styles/app.scss";
import { getWh, getQuery, addWindowQueue } from "./utils/tools";
import adaptPad from "./utils/adaptPad";
import Global from "./global/Global";

declare global {
  interface Window {
    currentUser?: number;
  }
}

const setVh = () => {
  const set = () =>
    document
      .querySelector("html")
      .style.setProperty("--my-vh", `${getWh().height}px`);
  set();
  window.addEventListener("resize", () => {
    set();
  });
};

const setVw = () => {
  const set = () =>
    document
      .querySelector("html")
      .style.setProperty("--my-vw", `${getWh().width}px`);
  set();
  window.addEventListener("resize", () => {
    set();
  });
};

setVh();
setVw();

const model = getQuery("model");

if (model === "eruda") {
  // @ts-ignore
  import("eruda").then((eruda) => {
    eruda.default.init();
  });
}

addWindowQueue("resizeEvent");
adaptPad();

const ArticleLibrary = () => {
  render(
    // 这里和rails routes scope 得一致 
    <Router basename={MODEL_AUTH.basename}>
      <LastLocationProvider>
        <Global />
        <Switch>
          <ArticleLibraryRoute />
        </Switch>
      </LastLocationProvider>
    </Router>,
    document.getElementById("article_library")
  );
};

export default ArticleLibrary;
